import { faGavel, faTrophyStar } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Heading, HeadingSize } from 'components/Ui-Kits/Text'
import { useAppTranslation } from 'i18n/hooks'
import { bool } from 'prop-types'
import { useMemo } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

export const ItemMessage = ({ success }) => {
  const { t } = useAppTranslation()

  const label = useMemo(() => {
    if (success) {
      return (
        <Trans i18nKey="youWon">
          <br />
        </Trans>
      )
    }

    return t('itemHasClosed')
  }, [success, t])

  const icon = useMemo(() => (success ? faTrophyStar : faGavel), [success])

  return (
    <ItemMessageWrap success={success}>
      <Icon icon={icon} />
      <StyledHeading mb={0} size={HeadingSize.REGULAR} mt={0}>
        {label}
      </StyledHeading>
    </ItemMessageWrap>
  )
}

ItemMessage.propTypes = {
  success: bool,
}

const ItemMessageWrap = styled.div`
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  box-sizing: border-box;
  border-width: 5px;
  border-style: solid;
  border: 5px solid var(--color-${({ success }) => (success ? 'green2' : 'primary')});
  background-color: ${({ success }) => (success ? 'rgba(17, 128, 3, 0.2)' : 'rgba(255, 255, 255, 0.1)')};
  color: var(--color-${({ success }) => (success ? 'green2' : 'primary')});
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;
`
const Icon = styled(FontAwesomeIcon)`
  font-size: 50px;
`
const StyledHeading = styled(Heading)`
  color: inherit;
  text-align: center;
`
